// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__mPBXr","label":"Completed_label__1gkwu"};